import { gql } from '@apollo/client';
import { useLazyQuery } from '@apollo/client';

const SPOT_SEO_PHOTOS_PAGI_SIMPLE = gql`
    query getSpot($id: ID!, $page: Int, $limit: Int) {
        spot(id: $id) {
            spotPhotos(page: $page, limit: $limit) {
                id
                imageAws
            }
        }
    }
`;

const SPOT_SEO_PHOTOS_PAGI = gql`
    query getSpot($id: ID!, $page: Int, $limit: Int) {
        spot(id: $id) {
            spotPhotos(page: $page, limit: $limit) {
                id
                imageAws
            }
            nearbySpots {
                id
                spotPhotos(page: $page, limit: $limit) {
                    id
                    imageAws
                }
            }
        }
    }
`;

export default function useGetSpotPhotosPaginated(includeNearby) {
    const [getSpotPhotosPaged, { data, loading }] = useLazyQuery(includeNearby ? SPOT_SEO_PHOTOS_PAGI : SPOT_SEO_PHOTOS_PAGI_SIMPLE);
    return { getSpotPhotosPaged, data, loading };
}
